export default __webpack_public_path__ + "static/media/eduPurple.0d11a0cf.svg";